var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"title":_vm.workspace.name,"toptitle":_vm.$t('settings.workspace.info.edit'),"name":"settings-workspace-edit","width":400}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('settings-workspace-form',{attrs:{"workspace":_vm.workspace,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }